import { render, staticRenderFns } from "./AreaGoodsReport.vue?vue&type=template&id=64d55eae&scoped=true"
import script from "./AreaGoodsReport.vue?vue&type=script&lang=ts"
export * from "./AreaGoodsReport.vue?vue&type=script&lang=ts"
import style0 from "./AreaGoodsReport.vue?vue&type=style&index=0&id=64d55eae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d55eae",
  null
  
)

export default component.exports